import { render, staticRenderFns } from "./detail_all.vue?vue&type=template&id=35e637de&scoped=true&"
import script from "./detail_all.vue?vue&type=script&lang=js&"
export * from "./detail_all.vue?vue&type=script&lang=js&"
import style0 from "./detail_all.vue?vue&type=style&index=0&id=35e637de&prod&scoped=true&lang=css&"
import style1 from "./detail_all.vue?vue&type=style&index=1&id=35e637de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e637de",
  null
  
)

export default component.exports